<template>
    <form
        :onsubmit="'return false'"
        :class="['subscription-form', form.class]"
        v-on:submit.prevent="subscribe"
    >
        <div class="flex p-0 mb-4" v-bind:class="{ 'lg:w-full': form.showImage }">
            <div class="p-0 mb-0 w-full">
                <label :for="'payload-email-address-' + id">
                    <input v-if="position == 'PopUp'"
                           class="email w-full"
                           aria-labelledby="payload-enter-email"
                           :aria-label="translations.email_enter_email"
                           :placeholder="'NAME@EMAIL.COM'"
                           :id="'payload-email-address-' + id"
                           v-model="payload.email"
                           name="email"
                           type="email"
                           required
                    />
                    <input v-else
                           class="email w-full"
                           aria-labelledby="payload-enter-email"
                           :aria-label="translations.email_enter_email"
                           :placeholder="translations.email_enter_email"
                           :id="'payload-email-address-' + id"
                           v-model="payload.email"
                           name="email"
                           type="email"
                           required
                    />
                </label>

                <input name="country" v-bind:value="payload.country" type="hidden"/>
                <input name="current_url" v-bind:value="payload.current_url" type="hidden"/>
                <input name="us_state" v-bind:value="payload.region_code" type="hidden"/>
                <input
                    name="hidden_input"
                    v-bind:value="payload.hidden_input"
                    style="display: none"
                />
                <input name="debug" v-bind:value="payload.debug" type="hidden"/>
                <input
                    name="product_type_feature"
                    v-bind:value="payload.product_type_feature"
                    type="hidden"
                />
            </div>
        </div>
        <div v-if="(position != 'PopUp')" class="agree-text text-left sm:w-full pr-4 p-0 w-full flex">
            <div :id="'fake-checkbox-container-' + id">
                <fake-checkbox-tw
                    :id="id"
                    :check="fakeCheckbox.checked"
                    :required="fakeCheckbox.required"
                    :name="fakeCheckbox.name"
                    :validation-message="translations.checkbox_validation_error"
                >
                </fake-checkbox-tw>
            </div>
            <div class="ml-2 flex items-center">
                <span @click="flip" :id="'label-' + id" class="agree-message">
                    <p v-html="translations.agree_message"></p>
                </span>
            </div>
        </div>
        <!-- <div
            class="flex p-0"
            v-bind:class="{
                'justify-content-left': form.showImage,
                'justify-content-center': !form.showImage,
            }"
        >
            <button
                :class="(position == 'PopUp') ? 'lg:w-full pr-4 pl-4 button-blue':'lg:w-1/2 pr-4 pl-4 sm:w-full pr-4 pl-4 button-blue'"
                type="submit"
                :disabled="commencing === true"
            >
                {{ translations.subscribe_button_text }}
            </button>
        </div> -->
        <div v-if="(position == 'PopUp')" class="agree-text text-left sm:w-full p-0 mb-3 w-full flex">
            <div :id="'fake-checkbox-container-' + id">
                <fake-checkbox-tw
                    :id="id"
                    :check="fakeCheckbox.checked"
                    :required="fakeCheckbox.required"
                    :name="fakeCheckbox.name"
                    :validation-message="translations.checkbox_validation_error"
                    :popUp="true"
                >
                </fake-checkbox-tw>
            </div>
            <div class="ml-2 flex items-center">
                <span @click="flip" :id="'label-' + id" class="agree-message">
                    <p v-html="translations.agree_message"></p>
                </span>
            </div>
        </div>
        <div
            class="flex p-0 mb-4"
            v-bind:class="{
                'justify-content-left': form.showImage,
                'justify-content-center': !form.showImage,
            }"
        >
            <button
                :class="(position == 'PopUp') ? 'w-full pr-4 pl-4 button-blue':'w-full pr-4 pl-4 sm:w-full pr-4 pl-4 email-signup-button-blue bg-gdc-blue-600 hover:bg-gdc-blue-700'"
                type="submit"
                :disabled="commencing === true"
            >
                {{ translations.subscribe_button_text }}
            </button>
        </div>
    </form>
</template>

<script>
import {NewsLetterSubscription} from '../../NewsLetterSubscription';

export default {
    mounted() {
        this.id = this.$root.id;
        this.payload.current_url = this.$root.current_url;
        this.payload.country = this.$root.country;
        this.payload.hidden_input = this.$root.hidden_input;
        this.payload.debug = this.$root.class;
        this.payload.product_type_feature = this.$root.product_type_feature;
        this.fakeCheckbox = this.$root.fakeCheckbox;
        this.translations = this.$root.translations;
        this.form.class = this.$root.class;
        this.form.showImage = this.$root.showImage;
        this.position = this.$root.position;

        if (this.$root.class === 'email-capture-static') {
            this.payload.debug = 'email-capture-top';
        }

        if (this.$root.us_state) {
            this.payload.us_state = this.$root.us_state;
        }
    },

    data() {
        return {
            id: null,
            form: {
                class: 'email-capture-static',
                showImage: null,
            },
            payload: {
                current_url: null,
                country: 'US',
                email: null,
                us_state: null,
                debug: null,
                product_type_feature: null,
                region_code: document.querySelector('html').dataset.regioncode ? document.querySelector('html').dataset.regioncode.toUpperCase() : "",
            },
            hidden_input: null,
            translations: {
                email_enter_email: null,
                subscribe_button_text: null,
                agree_message: null,
                input_validation_error: null,
                checkbox_validation_error: null,
                email_validation_error: null,
            },
            commencing: false,
            subscribed: null,
            fakeCheckbox: {
                checked: false,
                required: true,
                name: null,
            },
            position: null,
        };
    },
    methods: {
        flip() {
            this.$children[0].flipState().toggleCheckbox();
        },
        subscribe(event) {
            let self = this;
            self.commencing = true;

            let data = $(event.target).serializeArray();

            let payload = {};
            data.forEach(function (item) {
                payload[item.name] = item.value;
            });

            let subscription = new NewsLetterSubscription();

            subscription.subscribe(payload).then(function (response) {
                if (
                    typeof response.status !== 'undefined' &&
                    response.status.toLowerCase() === 'subscribed' &&
                    payload.hidden_input === ''
                ) {
                    self.subscribed = true;

                    let subscriptionEvent = new CustomEvent('newsletter.subscribed', {
                        detail: {
                            status: true,
                            id: self.id,
                        },
                    });
                    console.log('EVENT SUBSCRIBED FIRED', subscriptionEvent);
                    document.dispatchEvent(subscriptionEvent);

                    ktag.subscribe(payload.email)
                } else {
                    self.subscribed = false;
                    let subscriptionEvent = new CustomEvent('newsletter.subscribed', {
                        detail: {
                            status: false,
                            id: self.id,
                        },
                    });

                    document.dispatchEvent(subscriptionEvent);
                }
                self.commencing = false;
            });
        },
        setEmailInputValidationMessage(event) {
            if (event.target.validity.typeMismatch) {
                event.target.setCustomValidity(this.translations.email_validation_error);
            } else if (event.target.validity.valueMissing) {
                event.target.setCustomValidity(this.translations.input_validation_error);
            } else {
                event.target.setCustomValidity('');
            }
        },
    },
};
</script>
